import { useState } from 'react'
import { AnimatePresence, motion } from 'motion/react'
import { isAppleDevice } from 'utils'
import { AppIcon, CrossIcon } from 'assets/icons'
import { APP_URL } from 'config'
import { trackEvent } from 'analytics/trackFunctions'

const AppBannerToast = () => {
  const [isVisible, setIsVisible] = useState(true)

  function handleClose() {
    setIsVisible(false)
  }

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ y: -100 }}
          animate={{ y: 0 }}
          transition={{ duration: 0.6, delay: 3, type: 'spring' }}
          exit={{ y: -100, opacity: 0, transition: { delay: 0 } }}
          className='h-16 py-2 pl-4 pr-2 md:px-6 fixed shadow-loan-card z-10 rounded-b-xl bg-white w-full flex items-center md:max-w-[50%] md:right-0 md:top-0'
          onClick={(e) => e.stopPropagation()}
        >
          <button
            onClick={() => {
              trackEvent({ eventName: 'login_boton_header_descarga_app' })
              window
                .open(isAppleDevice ? APP_URL.ios : APP_URL.android, '_blank')
                .focus()
            }}
            type='button'
            className='flex items-center grow gap-2'
          >
            <AppIcon />
            <div className='leading-tight text-left'>
              <p className='text-2xs font-medium'>
                Wayni: Préstamos y Billetera
              </p>
              <p className='font-bold'>Descargar App</p>
            </div>
          </button>
          <button
            type='button'
            className='pl-3 md:pr-1 py-3'
            onClick={handleClose}
          >
            <span className='sr-only'>Cerrar banner</span>
            <CrossIcon />
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  )
}

export default AppBannerToast
